import {Injectable} from "@angular/core";

import {ClientConfiguration} from "../configuration/client.config";
import {CssSentence, CssWord, ContentCssClass} from "../../content/content-view.objects";
import {IReadingMode} from "../../reading/reading.component";
import {ContentCursor, AllowedSelectionType} from "../content/content.cursor";
import {ACTIVITY_STATUS, ActivityEvent, ActivityEventData} from "../../event/ActivityEvent";
import {EventBus} from "../../event/EventBus";
import {ContentFormatter} from "../../content/content.formatter";
import {UserModelService} from "../usermodel/usermodel.service";
import {StepService} from "../step/step.service";
import {StudentConfiguration} from "../assignment/student.configuration";
import {AudioQueueService} from "../audio-playback/audioqueue.service";
import {AudioQueueItem, TranslateAudio} from "../audio-playback/audioqueue.item";
import {AudioQueueEvent, InterruptAudio} from "../../event/AudioQueueEvent";
import {BugsnagLoggingService} from "../logging/bugsnag-logging.service";

@Injectable()
export class PreviewService implements IReadingMode {

    constructor(private audioQueueService:AudioQueueService,
                private config:ClientConfiguration,
                private studentConfiguration:StudentConfiguration,
                private contentCursor:ContentCursor,
                private eventBus: EventBus,
                private stepService: StepService,
                private log: BugsnagLoggingService,
                private userModelService: UserModelService) {
    }

    public sentenceFinishedCallback:Function;

    public startWord(word:CssWord):void {
        if (!word || !word.userSelected) {
            return;
        }

        if (this.stepService.canUseGlossary() && word.glossary && this.studentConfiguration.glossaryAvailable) {
            this.eventBus.next(
                new ActivityEvent(ACTIVITY_STATUS.activity_start, new ActivityEventData({
                    type: "glossary",
                    word: word
                }))
            );
        } else {
            let mp3Path:string = this.config.audioUrl + word.audio;
            this.eventBus.next(new AudioQueueEvent(
                [new AudioQueueItem(mp3Path, TranslateAudio.NO)], InterruptAudio.YES));
        }
    }

    public startSentence(sentenceItem:CssSentence, callback:Function):void {
    }

    public activate(isPipeline: boolean):void {

        let cssClass:ContentCssClass;
        if (this.stepService.isPreview || this.stepService.isWordWall) {
            cssClass = ContentCssClass.MODE_PREVIEW;
        } else {
            if (this.userModelService.canPlayback) {
                cssClass = ContentCssClass.MODE_RECORDING_DONE;
                this.log.log("calling format colors from previewService: selection = " +
                             this.contentCursor.selection.referenceStory());
                this.formatSelectionColors();
            } else {
                cssClass = ContentCssClass.MODE_RECORDING_PAUSED;
                this.log.log("calling format read/unread from previewService: selection = " +
                             this.contentCursor.selection.referenceStory() + " currentSentence="
                             + this.userModelService.currentSentenceId);
                this.formatSelectionRecorded();
            }
        }
        let selectedId = this.contentCursor.selectedWord ? this.contentCursor.selectedWord.id : "undefined";
        let selectedSentenceId = this.contentCursor.selectedSentence ?
                                 this.contentCursor.selectedSentence.id : "undefined";
        console.log("initial cursor word: "  +  selectedId + " sentence: " + selectedSentenceId);
        if (!isPipeline) {
            this.selectCurrentWord();
        }
        this.contentCursor.setMode(cssClass);
    }

    public pause():void {
        this.audioQueueService.hardReset();
    }

    public get changeUIWhenActive():boolean {
        return false;
    }

    public get allowedSelectionType(): AllowedSelectionType {
        return AllowedSelectionType.WORD;
    }

    // format word colors for a complete recording
    private formatSelectionColors(): void {
        ContentFormatter.formatSelectionFromRecordReadingStates(this.contentCursor.selection,
                                                                this.userModelService.recordReadingStates);
    }
    // format grey vs. black text for a partial (or no) recording
    private formatSelectionRecorded(): void {
        console.log("format read/unread (gray vs black): currentSentenceId = "
                    + this.userModelService.currentSentenceId.toString());
        ContentFormatter.formatSelectionFromCurrentRecordingSentence(this.contentCursor.selection,
                                                                this.userModelService.currentSentenceId);
    }

    public selectCurrentWord(): void {
        let selectWordId = this.contentCursor.selectedWord ? this.contentCursor.selectedWord.id : "undefined";
        let selectSentenceId = this.contentCursor.selectedSentence ? this.contentCursor.selectedSentence.id : "undefined";
        console.log("Before selectCurrentWord:" + selectSentenceId + "/" + selectWordId);
        if (!this.contentCursor.selectedSentence) {
            let nextSentenceId = 1;
            if (!this.stepService.isPreview && !this.userModelService.canPlayback
                && !this.contentCursor.selectedSentence) {
                nextSentenceId = this.userModelService.currentSentenceId + 1;
            }
            let nextSentence = this.contentCursor.selection.sentenceFromId(nextSentenceId.toString());
            if (nextSentence) {
                this.contentCursor.startAtWord(nextSentence.firstChild());
            } else {
                console.error("Can't select current sentence and word using sentence id " + nextSentenceId);
            }
        } else {
            // if selectedSentence is set but not word, we are transitioning from a playback mode
            if (!this.contentCursor.selectedWord && this.contentCursor.getMode() !== ContentCssClass.MODE_RECORDING) {
                this.contentCursor.startAtWord(this.contentCursor.selectedSentence.firstChild());
            }
        }
        selectWordId = this.contentCursor.selectedWord ? this.contentCursor.selectedWord.id : "undefined";
        selectSentenceId = this.contentCursor.selectedSentence ? this.contentCursor.selectedSentence.id : "undefined";
        console.log("After selectCurrentWord:" + selectSentenceId + "/" + selectWordId);
    }

}
